<template>
  <div>    
    <v-card-text class="pa-0">
      <v-row>
        <v-col cols="12" xs="12" md="5">
          <v-toolbar flat>
            Available
            <v-spacer></v-spacer>
            <v-text-field dense flat
              v-model="available.term"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
          <v-data-table dense
            :headers="available.headers"
            :items="available.items"
            :search="available.term"
            :loading="available.loading"
            loading-text="Loading... Please wait"
            show-select
            v-model="available.selected"            
            item-key="name"
            :items-per-page="15"         
            :mobile-breakpoint="0"  
          > 
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox>
            </template>            
          </v-data-table>
        </v-col>
        <v-col cols="12" xs="12" md="2">
          <v-container grid-list-lg>
            <v-layout row align="center">
              <v-flex xs6 md12>
                <v-btn color="green" small dark @click="addRoutes" block>
                assign <v-icon right>arrow_forward</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs6 md12>
                <v-btn color="orange" small dark @click="removeRoutes" block>
                  <v-icon left>arrow_back</v-icon> revoke 
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>  
        </v-col>
        <v-col cols="12" xs="12" md="5">
           <v-toolbar flat>
            Assigned
            <v-spacer></v-spacer>
            <v-text-field dense flat
              v-model="assigned.term"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
          <v-data-table dense
            :headers="assigned.headers"
            :items="assigned.items"
            :search="assigned.term"
            :loading="assigned.loading"
            loading-text="Loading... Please wait"
            show-select
            v-model="assigned.selected"            
            item-key="name"
            :items-per-page="15"
            :mobile-breakpoint="0"
          > 
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox>
            </template>            
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>    
  </div>  
</template>

<script>
import { Ripple } from 'vuetify/lib/directives'
import { debounce } from 'lodash'
import Model from '@/app/models/Admin'
const  model = new Model()


export default {  
  directives : {Ripple},
  data : () => ({    
    perPage:'10',
    perPageOptions: ['10', '20', '50', '-1'],
    available : {      
      items : [], checkedAll:false, selected : [],
      loading : false, term : null,
      headers : [{ text: 'Route', value: 'name' }],
    },
    assigned : {
      items : [], checkedAll:false, selected : [],
      loading : false, term : null,
      headers : [{ text: 'Route', value: 'name' }],
    },
    term : null,
    items: [],     
    page : 0,      
    totalPages: 0,      
    loading: false,
    status: {1:'active',0:'inactive'},    
  }),
  computed: {   
    filterAvailable(){
      if (!this.available.term || this.available.term.length < 1) {       
        return this.isChecked(this.available.items, this.available.checkedAll)
      }
      return this.isChecked(this.available.items.filter(item => {
        const textOne    = item.name.toLowerCase()
        const searchText = this.available.term.toLowerCase()
        return textOne.indexOf(searchText) > -1; 
      }), this.available.checkedAll)      
    },
    filterAssigned(){
      if (!this.assigned.term || this.assigned.term.length < 1) {
        return this.isChecked(this.assigned.items, this.assigned.checkedAll)
      }
      return this.isChecked(this.assigned.items.filter(item => {
        const textOne    = item.name.toLowerCase()
        const searchText = this.assigned.term.toLowerCase()
        //return item.name.toLowerCase().startsWith(this.available.term.toLowerCase())
        return textOne.indexOf(searchText) > -1; 
      }), this.assigned.checkedAll)           
    },
  },
  created () {
    this.init()
  },
  methods: {    

    searchAvailable: debounce(function (term) {
      this.available.term = term;                  
    }, 800),

    searchAssigned : debounce(function (term) {
      this.assigned.term = term;            
    }, 800),

    isChecked(result, status){
      result.forEach(item=>{item.checked = status ? true:false});
      return result;
    },

    init () {
      this.available.loading = true; this.assigned.loading = true;             
      model.routes().then(response => {                                        
        this.readItems(response)
        this.available.loading = false
        this.assigned.loading  = false
      })
    },

    readItems (response){
      this.available.items   = []; this.assigned.items = [];   
      if(Array.isArray(response.available)){
        response.available.forEach(item=>{
          this.available.items.push({checked:false, name:item});            
        });          
      } 
      if(Array.isArray(response.assigned)){
        response.assigned.forEach(item=>{
          this.assigned.items.push({checked:false, name:item});            
        });          
      }
    },

    selectAvailable (data) {
      const idx = this.available.items.findIndex(u => u.name === data.name)
      this.available.items[idx].checked = !this.available.items[idx].checked           
    },

    selectAssigned (data) {
      const idx = this.assigned.items.findIndex(u => u.name === data.name)
      this.assigned.items[idx].checked = !this.assigned.items[idx].checked
    },

    addRoutes(){
      let arr = []; this.available.selected.forEach(item=>{arr.push(item.name)})
      this.available.loading = true;
      model.addRoutes({routes:arr}).then(res=>{
        this.available.loading = false; this.readItems(res)
      })
    },

    removeRoutes(){
      let arr = []; this.assigned.selected.forEach(item=>{arr.push(item.name)})
      this.assigned.loading = true;
      model.removeRoutes({routes:arr}).then(res=>{
        this.assigned.loading = false; this.readItems(res)
      })
    },

    getStatusColor (status) {
      if (status === 1) {
        return 'success'
      }

      if (status === 'processing') {
        return 'info'
      }

      return 'danger'
    },
  },  
}
</script>